import deleteItemsBasedOnNodeIds from '../actions/actionCreators/deleteItemsBasedOnNodeIds';
import { deleteItems } from '../actions/deleteItems';
import { selectNextItemPart } from 'owa-mail-actions/lib/mailListSelectionActions';
import { listViewStore } from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import getItemIdsToShowFromNodeIds from 'owa-mail-store/lib/selectors/getItemIdsToShowFromNodeIds';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import { orchestrator } from 'satcheljs';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { mailStore } from 'owa-mail-store';

export default orchestrator(deleteItemsBasedOnNodeIds, actionMessage => {
    const itemIds = getItemIdsToShowFromNodeIds(actionMessage.nodeIds);
    const tableView = listViewStore.tableViews.get(actionMessage.tableViewId);

    // Only select next item part when the user is deleting a selected item part. Unselected item parts
    // can be deleted via the item part hover icon
    if (
        listViewStore.expandedConversationViewState.selectedNodeIds.indexOf(
            actionMessage.nodeIds[0]
        ) > -1
    ) {
        selectNextItemPart(listViewStore.expandedConversationViewState.expandedRowKey, tableView);
    }

    deleteItems(
        itemIds,
        doesFolderIdEqualName(tableView.tableQuery.folderId, 'deleteditems') ||
            isAnyItemInDeletedItems(itemIds)
            ? 'SoftDelete'
            : 'MoveToDeletedItems',
        null /* instrumentationContext */,
        actionMessage.actionSource,
        getMailboxInfo(tableView)
    );
});

function isAnyItemInDeletedItems(itemIds: string[]) {
    for (const itemId of itemIds) {
        const item = mailStore.items.get(itemId);
        if (
            item &&
            item.ParentFolderId &&
            folderIdToName(item.ParentFolderId.Id) == 'deleteditems'
        ) {
            return true;
        }
    }
    return false;
}
